import { h } from 'preact'

export const Hello = ({ title, background = 'white' }) => {
   return (
      <div class={background === 'grey' ? 'bg-gray2' : 'bg-white'}>
         <div class="container-fluid">
            <div class="row pb-1 pt-1 pt-md-2">
               <div class="col-12">
                  <p class="h2 no-signature mw-100 mb-0">{title}</p>
               </div>
            </div>
         </div>
      </div>
   )
}
